// extracted by mini-css-extract-plugin
module.exports = {"xxxsmall":"8px","xxsmall":"9px","xsmall":"10px","small":"12px","medium":"14px","large":"16px","xlarge":"18px","xxlarge":"20px","xxxlarge":"23px","title":"26px","largeTitle":"36px"};